import type { Result, AppError } from '../../error/types';
import { isEnvironment } from './isEnvironment';
import { ENVIRONMENTS } from '../constants/ENVIRONMENTS';

/**
 * @group Functions
 * @summary <blockquote>Checks if the current environment is preview.</blockquote>
 * 
 * @returns Result containing true if preview, false otherwise
 * 
 * @example
 * ```typescript
 * import { isPreview } from '@shared/utils';
 * 
 * const result = isPreview();
 * result.match({
 *   ok: (isPrev) => isPrev && console.log('Preview mode'),
 *   err: (error) => console.error(`Check failed: ${error.errorMessage}`)
 * });
 * ```
 */
export function isPreview(): Result<boolean, AppError> {
  return isEnvironment(ENVIRONMENTS.PREVIEW);
}